/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum FAVORITE_TYPE {
	MesClientsClients = 0,
	MesClientsContrats = 1,
	MesClientsFactures = 2,
	MesClientsRegistresDuPersonnel = 3,
	MesClientsListeTravailleursHandicapes = 4,
	MesClientsDocumentsMisADisposition = 5,
	MesClientsRelevesHeures = 6,
	MesClientsProlongationsContrats = 7,
	MesInterimairesInterimaires = 8,
	MesInterimairesContrats = 9,
	MesInterimairesBulletinsSalaire = 10,
	MesInterimairesCertificatsTravail = 11,
	MesInterimairesAttestationsImpots = 12,
	MesInterimairesJustificatifsDeplacements = 13,
	MesInterimairesAttestationsPoleEmploi = 14,
	MesInterimairesDocumentsMisADisposition = 15,
	MesInterimairesDemandesAcompte = 16,
	CommandesVueDensemble = 17,
	CommandesCommandes = 18,
	CommandesBoiteAOutils = 19,
	OrganisationVisionDensemble = 20,
	OrganisationMesUtilisateurs = 21,
	OrganisationRoles = 22,
	OrganisationTags = 23,
	OrganisationParametres = 24,
	OrganisationLieuxDeMission = 25,
	ParametresArchives = 26,
	ParametresActualites = 27,
	ParametresStatistiques = 28,
	ParametresCgvCtt = 29,
	ParametresParametres = 30,
	MesDocumentsContrats = 31,
	MesDocumentsFactures = 32,
	MesDocumentsRegistresDuPersonnel = 33,
	MesDocumentsListeTravailleursHandicapes = 34,
	MesDocumentsDocumentsMisADisposition = 35,
	MesTraitementsRelevesHeures = 36,
	MesTraitementsProlongationsContrats = 37,
	MesTraitementsCommandes = 38,
	MesDocumentsViePersonnelle = 39,
	MesDocumentsVieProfessionnelleContrats = 40,
	MesDocumentsVieProfessionnelleBulletinsSalaire = 41,
	MesDocumentsVieProfessionnelleCertificatsTravail = 42,
	MesDocumentsVieProfessionnelleAttestionsImpots = 43,
	MesDocumentsVieProfessionnelleJustificatifsDeplacements = 44,
	MesDocumentsVieProfessionnelleAttestationsPoleEmploi = 45,
	MesDocumentsVieProfessionnelleDocumentsMisADisposition = 46,
	MesTraitementsDisponibilites = 47,
	MesTraitementsDemandesAcompte = 48,
	MesTraitementsRelevesHeuresInterimaire = 49,
	MesTraitementsOffresDeMission = 50,
	OrganisationSocietes = 51,
	MesTraitementsMesAgences = 52,
}
